export let Terms;(function(a){a.Products="products",a.Posts="posts",a.ProductCategories="productCategories",a.Pages="pages"})(Terms||(Terms={}));